module.exports = __webpack_public_path__ + "img/addplus.17ecffd5.svg";